import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';

const FALLBACK_IMG = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="675"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="%2314122a"/><stop offset="1" stop-color="%23201c3d"/></linearGradient></defs><rect width="100%" height="100%" fill="url(%23g)"/><text x="50%" y="54%" fill="%23bdb8e6" opacity="0.6" font-family="system-ui" font-size="42" text-anchor="middle">No cover</text></svg>';

function Card({ game }) {
    const [src, setSrc] = useState(game.image_url || FALLBACK_IMG);
    return (
        <Link to={`/game/${game.slug}`} className="gw-tile">
            <img src={src} alt={game.name} loading="lazy" onError={()=>setSrc(FALLBACK_IMG)} />
            <div className="gw-tile-grad" />
            <div className="gw-tile-title">{game.name}</div>
        </Link>
    );
}

export default function Home() {
    const [items, setItems] = useState([]);
    const [q, setQ] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let m = true;
        api.get('/games').then(d => { if (m) setItems(Array.isArray(d) ? d : []); }).finally(()=>setLoading(false));
        return () => { m = false; };
    }, []);

    const list = useMemo(() => {
        const s = q.trim().toLowerCase();
        if (!s) return items;
        return items.filter(x => (x.name || '').toLowerCase().includes(s));
    }, [items, q]);

    return (
        <div className="gw-shell">
            <div className="gw-hero-mini">
                <h1 className="gw-h1">Hry</h1>
                <input className="gw-searchbox" placeholder="Hledat hry" value={q} onChange={e=>setQ(e.target.value)} />
            </div>

            <div className="gw-grid-tiles">
                {loading && Array.from({length:8}).map((_,i)=>(
                    <div key={i} className="gw-tile sk">
                        <div className="sk-media" />
                        <div className="sk-bar" />
                    </div>
                ))}
                {!loading && list.map(g => <Card key={g.slug} game={g} />)}
                {!loading && list.length === 0 && <div className="gw-empty">Nic nenalezeno</div>}
            </div>
        </div>
    );
}
